module.exports = __webpack_public_path__ + "img/img_capability_retail@3x.2a338f88.png";